<template>
  <v-container fluid class="main-container px-0 mx-0">
    <v-row style="height: auto" class="px-0 mx-0">
      <v-col cols="12" class="mx-0 px-0">
        <v-row class="mx-0 px-0">
          <v-col cols="12" class="mx-0 px-0" v-if="!loading && mentor.uuid">
            <v-card flat class="mx-0 px-0">
              <v-row class="mx-0 px-0">
                <v-col cols="12" class="px-0 mx-0 side-bar-header-section"/>
                <v-col cols="12" class="px-0 mx-0 d-flex flex-row justify-space-between" style="position: relative;">
                  <v-btn color="secondary" elevation="0" class="" style="border-radius: 2em; color: #0033AA" to="/home">
                    <v-icon color="primary">mdi-home</v-icon> Home
                  </v-btn>
                  <Avatar
                      :canRouteToProfile="false"
                      :styles="avatarStyles"
                      :user="mentor"
                      size="120"
                  />
                  <div class="d-flex flex-row pr-4">
                    <v-btn
                        small
                        elevation="0"
                        style="background-color: transparent;"
                        v-if="isAuthenticated && user.uuid === mentor.uuid"
                        to="/profile"
                    >
                      <v-icon style=" border-bottom: .01em solid gray">mdi-pencil</v-icon>
                    </v-btn>
                    <v-menu left min-width="200px" max-width="250px" offset-x rounded>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on"  color="primary">mdi-share</v-icon>
                      </template>
                      <v-card class="pa-0">
                        <v-list-item-content class="pa-0">
                          <div class="text-left d-flex flex-column pa-0">
                            <v-list-item>
                              <v-btn
                                  class="d-flex justify-space-between"
                                  v-clipboard:copy="profileUrl"
                                  v-clipboard:success="() => $emit('profileUrlCopySuccess')"
                                  v-clipboard:error="() => $emit('profileUrlCopyError')"
                                  block
                                  text
                              >
                                <div class="font-weight-light pr-1">
                                  Copy Profile Link
                                </div>
                                <v-icon >mdi-content-copy</v-icon>
                              </v-btn>
                            </v-list-item>
                          </div>
                        </v-list-item-content>
                      </v-card>
                    </v-menu>
                  </div>
                </v-col>
                <v-card-title class="font-weight-bold mx-auto">{{ displayNameOrEmail }}</v-card-title>
                <v-col cols="12" v-if="mentor.profile.biography" class="pb-0 d-flex flex-row align-center justify-center">
                  <p class="mx-4 text-center">
                    {{ mentor.profile.biography }}
                  </p>
                </v-col>
                <v-col cols="12" class="pa-0 d-flex flex-row align-center justify-center">
                  <v-btn
                      v-if="user.uuid !== mentor.uuid"
                      :loading="followLoading"
                      :outlined="mentor.profile.has_followed"
                      class="elevation-0"
                      color="primary"
                      @click="() => isAuthenticated ? $emit('followMentor') : showAuthDialog()"
                      style="border-radius: 2em;"
                  >
                    {{ !mentor.profile.has_followed ? "Follow" : "UnFollow" }}
                  </v-btn>
                </v-col>
                <v-col
                    cols="12"
                    class="d-flex flex-row align-center justify-center"
                    v-if="!mentor.profile.instagram_link || !mentor.profile.facebook_link"
                >
                  <a

                      class="text-decoration-none mr-3"
                      :href="mentor.profile.instagram_link"
                      v-if="!mentor.profile.instagram_link"
                  >
                    <v-icon color="#333333">mdi-instagram</v-icon>
                  </a>
                  <a
                      class="text-decoration-none"
                      :href="mentor.profile.facebook_link"
                      v-if="!mentor.profile.facebook_link"
                  >
                    <v-icon color="#333333">mdi-facebook</v-icon>
                  </a>
                </v-col>
                <v-col cols="12" class="px-0 d-flex flex-row align-center justify-center">
                  <v-card flat class="activity-card">
                    <v-card-text>
                      <v-row class="ml-1">
                        <v-col cols="6 pl-0 d-flex justify-left align-center">
                          <v-icon class="mr-2">mdi-book-open-variant</v-icon>
                          {{numberOfPosts}} Blog posts
                        </v-col>
                        <v-col cols="6 pl-0 d-flex justify-end align-center">
                          <v-icon class="mr-2">mdi-tag-multiple</v-icon>
                          {{numberOfTags}} Tags followed
                        </v-col>
                        <v-col cols="6 px-0 d-flex justify-left align-center">
                          <v-icon class="mr-2">mdi-chat-outline</v-icon>
                          {{numberOfComments}} Comments written
                        </v-col>
                        <v-col cols="6 pl-2 d-flex justify-end align-center">
                          <v-icon class="mr-2">mdi-account-group</v-icon>
                          {{numberOfFollowers}} Followers
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" class="px-0">
                  <v-row class="my-0">
                    <v-col
                        cols="12"
                        class="py-0 d-flex flex-row align-center justify-center"
                        style="color: #909090; font-size: .9em "
                    >
                      Joined on {{ joinedAt }}
                    </v-col>
                    <v-col cols="12" class="pt-2 d-flex flex-row align-center justify-center">
                      <v-btn
                          v-if="mentor.uuid === user.uuid"
                          text
                          color="#FF0000"
                          @click="() => $emit('handleLogout')"
                      >
                        LogOut
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-skeleton-loader v-else type="card,article,article,article" width="100%"/>
        </v-row>
      </v-col>
      <v-col cols="12" class="px-0 mx-0">
        <v-row class="mx-0 px-0">
          <v-col cols="12" class="mx-0 pa-0 mt-4">
            <v-card flat class="right-section pb-10">
              <v-row>
                <v-col cols="12" class="px-10 pt-10">
                  <v-tabs v-model="tab" mobile-breakpoint="sm" class="ml-2 p-1" active-class="active-tab" slider-color="primary">
                    <v-tab>
                      Blogs
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item>
                      <v-row>
                        <v-col cols="12" v-if="!loading && blogs.length" class="d-flex flex-column">
                          <div class="d-flex flex-row justify-space-around flex-wrap" >
                            <BlogCard
                                v-for="(blog, index) in blogs"
                                :key="index"
                                :blog="blog"
                                show-border
                                card-width="30%"
                            />
                          </div>
                        </v-col>
                        <v-col cols="12" v-if="!loading && blogs.length">
                          <infinite-loading spinner="waveDots" @infinite="($state) => $emit('fetchMoreBlogs', $state)">
                            <div slot="no-results">
                              <v-chip small text-color="primary">You have caught up</v-chip>
                            </div>
                            <div slot="no-more">
                              <v-chip small text-color="primary">You have caught up</v-chip>
                            </div>
                          </infinite-loading>
                        </v-col>
                        <v-col cols="12" v-if="(!loading && !blogs.length)" class="bottom-wrapper">
                          <NoData
                              data-testid="empty-blogs-list"
                              :image="noBlogsImage"
                              :title="`${mentor.profile.first_name} ${mentor.profile.last_name} has no blogs published yet`"
                          />
                        </v-col>
                        <v-col cols="12" v-if="loading" class="d-flex flex-row flex-wrap justify-space-around">
                          <v-skeleton-loader
                              data-testid="v-skeleton-loader"
                              v-for="x in 6"
                              :key="x"
                              class="my-3"
                              type="card,article,list-item-avatar-three-line"
                              :width="$vuetify.breakpoint.xs ? '99%' : '30%'"
                          />
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <LogOutDialog
        :reveal="showLogOutDialog"
        @cancel="showLogOutDialog = false"
        @logOutSuccess="showLogOutDialog = false"
    />
  </v-container>
</template>

<script>
import BlogCard from "@/components/BlogCard";
import NoData from "@/components/NoData";
import authDialogMixin from "@/mixins/authDialogMixin";
import LogOutDialog from "@/components/LogOutDialog";
import Avatar from "@/components/Avatar";

export default {
  name: "MobileMentorProfile",
  mixins: [authDialogMixin],
  components: {Avatar, LogOutDialog, NoData, BlogCard},
  data() {
    return {
      tab: 0,
      avatarStyles: {
        position: "absolute",
        top: "-4em",
        left: '36%',
        border: ".5em solid #f5f6f8 !important",
      },
    }
  },
  props: {
    mentor: { type: Object, default: () => ({ id: "" })},
    blogs: { type: Array, default: () => []},
    user: { type: Object, default: () => ({ id: "" })},
    displayNameOrEmail: { type: String,  default: "" },
    profileUrl: { type: String,  default: "" },
    numberOfPosts: { type: String,  default: "" },
    numberOfComments: { type: String,  default: "0" },
    numberOfTags: { type: String,  default: "0" },
    numberOfFollowers: { type: String,  default: "0" },
    joinedAt: { type: String,  default: "" },
    loading: { type: Boolean, default: false },
    isAuthenticated: { type: Boolean, default: false },
    followLoading: { type: Boolean, default: false },
    showLogOutDialog: { type: Boolean, default: false },
    noBlogsImage: { required: true }
  },
}
</script>
<style lang="scss" scoped>
.v-btn {
  text-transform: none !important;
}
.main-container {
  background-color: #EAEFF9;
  min-height: 100vh;
  font-family: Montserrat, sans-serif;
}
.side-section {
  position: absolute;
  min-height: 70vh;
  top: 8vh;
}

.side-bar-header-section {
  height: 15vh;
  background-color: #0033AA;
}

.activity-card {
  width: 100%;
  background-color: rgba(217, 217, 217, 0.37);
  border-bottom: .1em solid #909090;
  border-top: .1em solid #909090;
  border-radius: 0;
}

.right-section {
  min-height: 70vh;
  background-color: white;
  width: 100%
}

</style>

